import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { formatExpirationDate, PERMANENT_EXPIRATION_I18N_KEY } from '../utils/utils';

/**
 * Display de `expiration_date`: año 9999 → «Permanente»; resto formato calendario (NIF-1016).
 * No usar para birthdate u otras fechas.
 */
@Pipe({
	name: 'expirationDate',
	standalone: true,
	pure: true,
})
export class ExpirationDatePipe implements PipeTransform {
	private readonly trans = inject(TranslateService);

	transform(value: string | Date | null | undefined, format?: string): string {
		return formatExpirationDate(
			value,
			format ?? 'dd/MM/yyyy',
			this.trans.instant(PERMANENT_EXPIRATION_I18N_KEY),
		);
	}
}
